import {Component, OnInit} from '@angular/core';
import {environment} from '~/environments/environment';
import {ActivatedRoute, Router} from '@angular/router';
import {AdService} from '@services/ad.service';
import {HttpClient} from '@angular/common/http';
import {AuthenticationService} from '@services/authentification.service';
import {MatDialog} from '@angular/material/dialog';
import {TrackingService} from '@services/tracking.service';
import {AlertService} from '@services/alert.service';

@Component({
    selector: 'app-open-ad',
    templateUrl: './open-ad.component.html',
    styleUrls: ['./open-ad.component.scss']
})
export class OpenAdComponent implements OnInit {

    params;
    stripe = Stripe(environment.stripeKey);

    constructor(
        private http: HttpClient,
        private route: ActivatedRoute,
        public dialog: MatDialog,
        private router: Router,
        private adService: AdService,
        private alertService: AlertService,
        public trackingService: TrackingService,
        public authenticationService: AuthenticationService,
    ) {
    }

    ngOnInit(): void {
        this.route.queryParams.subscribe(params => {
            let returnUrl = '';
            if (params.returnUrl) {
                returnUrl = params.returnUrl;
                window.history.replaceState( { }, "Résultats de recherche", params.returnUrl);
            }

            this.route.params.subscribe(params => {
                this.params = params;
                this.adService.openAd(params.id).subscribe(favorite => {
                    favorite.notary_price = null; // To calc them
                    favorite = this.adService.fillUSerInfo(favorite);
                    favorite = this.adService.updateValues(favorite);
                    favorite.pictures_string = favorite.pictures.join(';');
                    this.http.put(environment.apiUrl + 'app/favorite/' + favorite.id, favorite).subscribe(result => {
                        this.router.navigate(['/app/annonces', favorite.id, 'annonce'], {queryParams: {returnUrl}});
                    }, error => {
                        if (error != 'token_outdate') {
                            this.alertService.error('Une erreur est survenue lors de l\'enregistrement.');
                        }
                    });
                }, error => {
                    if (error != 'token_outdate') {
                        this.alertService.error('Annonce introuvable', true);
                        this.router.navigate(['/app/favorites']);
                    }
                });
            });
        });
    }

}
